import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchCountriesApi,
  fetchCurrencyApi,
  fetchStatesApi,
} from "../../api/locationApi";
import * as Endpoints from "../../entities/Endpoints";

// Async thunk to fetch countries
export const fetchCountries = createAsyncThunk(
  Endpoints.GET_COUNTRY,
  async (_, { rejectWithValue }) => {
    try {
      return await fetchCountriesApi();
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// Async thunk to fetch states by country code
export const fetchStates = createAsyncThunk(
  Endpoints.GET_STATE,
  async (countryId, { rejectWithValue }) => {
    try {
      return await fetchStatesApi(countryId);
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// Async thunk to fetch currency details
export const fetchCurrencyDetails = createAsyncThunk(
  Endpoints.GET_CURRENCY_DETAILS,
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchCurrencyApi();
      // Extract only currencyName from each currency object
      return response.map((currency) => currency.currencyName);
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// Location slice
const locationSlice = createSlice({
  name: "location",
  initialState: {
    countries: [],
    states: [],
    // Added currencies to state
    currencies: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCountries.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCountries.fulfilled, (state, action) => {
        state.isLoading = false;
        state.countries = action.payload;
      })
      .addCase(fetchCountries.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchStates.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchStates.fulfilled, (state, action) => {
        state.isLoading = false;
        state.states = action.payload;
      })
      .addCase(fetchStates.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchCurrencyDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCurrencyDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        // Store only currency names
        state.currencies = action.payload;
      })
      .addCase(fetchCurrencyDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const locationReducer = locationSlice.reducer;
